import React from "react";
import { Col, Row } from "reactstrap";

import UserStatus from "./UserStatus";
import FeelingButton from "../../common/OperatorButton";
import SearchButton from "../../common/OperatorButton";
import OtherOptionsButton from "../../common/OtherOptionsButton";
import EngagementTitle from "../../EngagementHistory/subcomponents/EngagementTitle";
import ClientInfoTitle from "../../ClientInformation/subcomponents/ClientInfoTitle/ClientInfoTitle";
import AditionalFieldsTitle from "../../AditionalFields/subcomponents/AditionalFieldsTitle";
import UpdateList from "../../EngagementHistory/subcomponents/UpdateList";

const MenuButtons = ({
  id,
  chatId,
  displayName,
  name,
  onChangeDisplayName,
  enableMood,
  enableMoreOptions,
  enableSearch,
  type,
  moreOptions,
  moreOpAction,
  onUpdate,
  isVisible,
  loadingData,
}) => {
  return (
    <div>
      <div className="p-3" style={{ height: "58px" }}>
        <Row>
          {id && displayName && (
            <UserStatus
              id={id}
              chatId={chatId}
              displayName={displayName}
              name={name}
              onChangeDisplayName={onChangeDisplayName}
            />
          )}
          {type && type === "engagementHistory" && <EngagementTitle />}
          {type && type === "chatInformation" && <ClientInfoTitle />}
          {type && type === "aditionalFields" && <AditionalFieldsTitle />}

          <Col xs="12" style={{ position: "absolute", right: 0 }}>
            <ul className="list-inline user-chat-nav text-right mb-0">
              {enableMood && (
                <FeelingButton icon={"mdi mdi-emoticon-happy-outline"} />
              )}
              {enableSearch && <SearchButton icon={"bx bx-search-alt-2"} />}
              {/* {!chatExpanded && (
                <ExpandOptionsButton
                  icon={chatExpanded ? "bx bx-collapse" : "bx bx-expand"}
                  onclick={chatExpanded ? collapse : exp}
                />
              )} */}
              {enableMoreOptions && (
                <OtherOptionsButton
                  options={moreOptions}
                  onclick={moreOpAction}
                />
              )}

              {isVisible && type && type === "engagementHistory" && (
                <UpdateList onClick={onUpdate} loading={loadingData} />
              )}
            </ul>
          </Col>
        </Row>
      </div>
      <hr className="mb-0" />
    </div>
  );
};
export default MenuButtons;
